import axios from 'axios';
import config from '../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../core/modules/common/tools/URLTools';

const fetchMailClasses = () => {
  const serviceURL = constructServiceURL({ endpoint: 'getMailClasses', stub: config.useStubbedEndpoints });

  return axios.get(serviceURL);
};
export default { fetchMailClasses };
